import axios from "axios"

const API = () => {
    return axios.create({
        baseURL: process.env.REACT_APP_GRIZZLY_API_URL
    })
}

export default API()